import { Routes } from '@angular/router';
import { etudiantGuard } from './guards/etudiant.guard';
import { restrictedAccessGuard } from './guards/restricted-access.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  // Routes publiques (sans guard)
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.page').then(m => m.RegisterPage)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.page').then(m => m.ResetPasswordPage)
  },
  {
    path: 'legal-notices',
    loadComponent: () => import('./pages/legal-notices/legal-notices').then(m => m.LegalNoticesPage)
  },
  {
    path: 'cgu',
    loadComponent: () => import('./pages/cgu/cgu').then(m => m.CguPage)
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
  },
  {
    path: 'more',
    loadComponent: () => import('./pages/more/more.page').then(m => m.MorePage),
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about').then(m => m.About),
  },
  // Routes protégées (nécessitent le profil 'etudiant')
  // Routes avec restriction d'accès (email étudiant requis pour RENOUVELLEMENT)
  {
    path: 'products',
    loadComponent: () => import('./pages/products/products.page').then(m => m.ProductsPage),
    canActivate: [etudiantGuard, restrictedAccessGuard]
  },
  {
    path: 'recent-donations',
    loadComponent: () => import('./pages/recent-donations/recent-donations.page').then(m => m.RecentDonationsPage),
    canActivate: [etudiantGuard, restrictedAccessGuard]
  },
  {
    path: 'cart',
    loadComponent: () => import('./pages/cart/cart.page').then(m => m.CartPage),
    canActivate: [etudiantGuard, restrictedAccessGuard]
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage),
    canActivate: [etudiantGuard]
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact').then(m => m.Contact),
    canActivate: [etudiantGuard]
  },
  {
    path: 'order-detail/:id',
    loadComponent: () => import('./pages/order-detail/order-detail').then(m => m.OrderDetail),
    canActivate: [etudiantGuard]
  },
  {
    path: 'order-history',
    loadComponent: () => import('./pages/order-history/order-history').then(m => m.OrderHistory),
    canActivate: [etudiantGuard]
  },
  {
    path: 'magasins',
    loadComponent: () => import('./pages/magasins/magasins.page').then(m => m.MagasinsPage)
  },
  {
    path: 'famille-produits/:id',
    loadComponent: () => import('./pages/famille-produits/famille-produits').then(m => m.FamilleProduits),
    canActivate: [etudiantGuard, restrictedAccessGuard]
  }
];
